"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatorOffice = exports.instrumentationKeyForOfficeAddinCLITools = exports.groupName = exports.usageDataJsonFilePath = void 0;
const os_1 = __importDefault(require("os"));
const path_1 = __importDefault(require("path"));
exports.usageDataJsonFilePath = path_1.default.join(os_1.default.homedir(), "/office-addin-usage-data.json");
exports.groupName = "office-addin-usage-data";
exports.instrumentationKeyForOfficeAddinCLITools = "de0d9e7c-1f46-4552-bc21-4e43e489a015";
exports.generatorOffice = "generator-office";
//# sourceMappingURL=defaults.js.map